import { RESERVED_TAGS } from '../../constants/constants';
import { FlagType, TagType } from '../../types/Flag';

interface Action {
  type: string;
  payload?: any;
}

interface FlagReducerType {
  loadingFlags: boolean;
  flagsSearch: FlagType[];
  tags: TagType[];
  tag: string;
}

const INITIAL_STATE: FlagReducerType = {
  loadingFlags: false,
  flagsSearch: [],
  tags: [],
  tag: ''
};

export default function reducer(state = INITIAL_STATE, action: Action) {
  switch (action.type) {
    case 'START_FETCHING_FLAGS':
      return { ...state, loadingFlags: action.payload };

    case 'FETCH_FLAGS': // Added this case for the new action type
    case 'FETCH_SEARCH_FLAGS':
      return {
        ...state,
        loadingFlags: false,
        flagsSearch: transformFlags(action.payload.data)
      };

    case 'RESET_FLAGS':
      return { ...state, flagsSearch: action.payload };

    case 'FETCH_TAGS_BY_USER':
      return {
        ...state,
        tags: action.payload.data
      };

    case 'MANAGE_TAG': {
      const {
        data: { tag, flashflag, flagId }
      } = action.payload;

      const tags = addTagIfNotExists(state.tags, tag, flashflag);
      const flags = updateFlagsWithNewTag(
        state.flagsSearch,
        flagId,
        tag,
        flashflag
      );

      return {
        ...state,
        flagsSearch: flags,
        tags,
        tag
      };
    }

    case 'UPDATE_DICTATION': {
      const { id, dictation } = action.payload.data;
      return {
        ...state,
        flagsSearch: state.flagsSearch.map((flag: FlagType) => {
          if (flag.flagId === id) {
            return { ...flag, dictation };
          }
          return flag;
        })
      };
    }

    default:
      return state;
  }
}

const transformFlags = (flags: FlagType[]): FlagType[] => {
  if (!Array.isArray(flags)) return [];
  return flags.map((flag: FlagType) => {
    if (flag.flashflag === true) {
      return {
        ...flag,
        tag: RESERVED_TAGS.UNTAGGED
      };
    }
    return flag;
  });
};

const updateFlagsWithNewTag = (
  flagsSearch: FlagType[],
  flagId: number,
  tag: string,
  flashflag: boolean
): FlagType[] => {
  if (!Array.isArray(flagsSearch)) return [];
  return flagsSearch.map((flag: FlagType) => {
    if (flag.flagId === flagId) {
      return { ...flag, tag, flashflag };
    }
    return flag;
  });
};

const addTagIfNotExists = (
  tags: TagType[],
  tag: string,
  flashflag: boolean
): TagType[] => {
  const tagExists = tags.some((item: TagType) => item.tag === tag);
  const isFlashflag = tag === RESERVED_TAGS.FLASH && flashflag;

  if (!tagExists && !isFlashflag) {
    const tagsArray = [...tags];
    tagsArray.push({
      tag,
      flashflag,
      flagId: null,
      id: null
    });
    return tagsArray.sort((a, b) => a.tag.localeCompare(b.tag));
  }
  return tags;
};
